export const CONTEXT_TYPE = {
  PREFIXES: 1,
  ASN: 2
};

export const ID_OF_MY_PREFIXES_CONTEXT = 'my-prefixes';

export const ROA_STATUS = {
  PUBLISHED: 'Published',
  NOT_PUBLISHED: 'NotPublished',
  MISMATCH: 'Mismatch'
};

export const ROUTE_OBJECT_STATUS = {
  PUBLISHED: 'Published',
  NOT_PUBLISHED: 'NotPublished',
  MISMATCH: 'Mismatch'
};

export const MISMATCH_TYPE = {
  ROA: 'roa',
  ROUTE_OBJECT: 'route_object'
};

export const ROUTING_STATUS_SORT_OPTION = {
  NONE: 0,
  PREFIX_ASCENDING: 1,
  PREFIX_DESCENDING: 2,
  ROA_ASCENDING: 3,
  ROA_DESCENDING: 4,
  ROUTE_OBJECT_ASCENDING: 5,
  ROUTE_OBJECT_DESCENDING: 6,
  BGP_ROUTE_ASCENDING: 7,
  BGP_ROUTE_DESCENDING: 8,
  ORIGIN_AS_ASCENDING: 9,
  ORIGIN_AS_DESCENDING: 10
};

export const ROUTING_STATUS_FILTER_OPTION = {
  NONE: 0,
  ROA_ISSUE: 1,
  ROUTE_OBJECT_ISSUE: 2,
  ONLY_CURRENT_ASN: 3
};

export const ORDER_TYPE = {
  ASC: 'asc',
  DESC: 'desc'
};
